<template>
  <v-dialog scrollable :value="value" @input="toggleModal()" fullscreen transition="dialog-bottom-transition">
    <v-card class="kbLight">
      <v-toolbar color="kbPurple" dark max-height="64px" flat>
        <v-btn icon text @click="toggleModal()">
          <v-icon small>arrow_back_ios</v-icon>
        </v-btn>
        <div class="text-h6">{{ $t('general.triggerDetails') }}</div>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal()">
          <v-icon small>
            clear
          </v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-container>
          <v-row v-if="loadingTrigger">
            <v-col class="text-center" cols="12" >
              <v-progress-circular indeterminate color="kbDarkBlueText"></v-progress-circular>
            </v-col>
          </v-row>

          <v-row v-else>
            <v-col cols="12" class="mb-2 pb-0">
              <v-card color="kbWhite">
                  <v-card-text>
                      <v-row class="pa-2"  align="center" >
                          <h5 class="kbDarkBlueText--text hidden-sm-and-up">{{selectedTrigger.title}}</h5>
                          <h3 class="kbDarkBlueText--text hidden-xs-only">{{selectedTrigger.title}}</h3>
                      </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-text>
                      <v-row>
                          <v-col cols="12" sm="6">
                              <v-list two-line
                                      rounded
                                      :color="$vuetify.theme.isDark ? 'kbLight' : ''"
                                      class="pa-0">
                                  <v-list-item>
                                      <v-list-item-action>
                                          <v-icon large color="kbBlue" dark>info</v-icon>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                          <v-list-item-title>
                                            {{selectedTrigger.description}}
                                          </v-list-item-title>
                                          <v-list-item-subtitle>
                                            {{ $t('general.description') }}
                                          </v-list-item-subtitle>
                                      </v-list-item-content>
                                  </v-list-item>
                              </v-list>
                          </v-col>

                          <v-col cols="12" sm="6">
                              <v-list two-line
                                      rounded
                                      :color="$vuetify.theme.isDark ? 'kbLight' : ''"
                                      class="pa-0">
                                  <v-list-item>
                                      <v-list-item-action>
                                          <v-icon large color="kbBlue">people</v-icon>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                          <v-list-item-title>
                                            {{totalTriggerUsers ? `${totalTriggerUsers} Personas` : 'Aún sin personas'}}
                                          </v-list-item-title>
                                          <v-list-item-subtitle>
                                            {{ $t('general.triggerScope') }}
                                          </v-list-item-subtitle>
                                      </v-list-item-content>
                                  </v-list-item>
                              </v-list>
                          </v-col>

                          <v-col cols="12" sm="6">
                              <v-list two-line
                                      rounded
                                      :color="$vuetify.theme.isDark ? 'kbLight' : ''"
                                      class="pa-0">
                                  <v-list-item>
                                      <v-list-item-action>
                                          <v-icon large color="kbBlue">send</v-icon>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                          <v-list-item-title v-if="selectedTrigger.createdAt">
                                            {{selectedTrigger.createdAt | moment('DD/MM/YYYY hh:mm a')}}
                                          </v-list-item-title>
                                          <v-list-item-subtitle>
                                            {{ $t('general.creationDate') }}
                                          </v-list-item-subtitle>
                                      </v-list-item-content>
                                  </v-list-item>
                              </v-list>
                          </v-col>

                          <v-col cols="12" sm="6">
                              <v-list two-line
                                      rounded
                                      :color="$vuetify.theme.isDark ? 'kbLight' : ''"
                                      class="pa-0">
                                  <v-list-item>
                                      <v-list-item-action>
                                          <v-icon large color="kbBlue">send</v-icon>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                          <v-list-item-title v-if="selectedTrigger.onActionTypeUserView">
                                            {{selectedTrigger.onActionTypeUserView.map(el => $t('general.action', { action: el })).join(', ')}}
                                          </v-list-item-title>
                                          <v-list-item-title v-else-if="selectedTrigger.onActionType">
                                            {{selectedTrigger.onActionType.map(el => $t('general.action', { action: el })).join(', ')}}
                                          </v-list-item-title>
                                          <v-list-item-subtitle>
                                            {{ $t('general.launchers') }}
                                          </v-list-item-subtitle>
                                      </v-list-item-content>
                                  </v-list-item>
                              </v-list>
                          </v-col>

                          <v-col cols="12" sm="6">
                              <v-list two-line
                                      rounded
                                      :color="$vuetify.theme.isDark ? 'kbLight' : ''"
                                      class="pa-0">
                                  <v-list-item>
                                      <v-list-item-action>
                                          <v-icon large color="kbBlue">send</v-icon>
                                      </v-list-item-action>

                                      <v-list-item-content>
                                          <v-list-item-title v-if="selectedTrigger.toDoUserView">
                                            {{selectedTrigger.toDoUserView.join(', ')}}
                                          </v-list-item-title>
                                          <v-list-item-title v-else-if="selectedTrigger.toDo">
                                            {{selectedTrigger.toDo.join(', ')}}
                                          </v-list-item-title>
                                          <v-list-item-subtitle>
                                            {{ $t('general.actionsToExecute') }}
                                          </v-list-item-subtitle>
                                      </v-list-item-content>
                                  </v-list-item>
                              </v-list>
                          </v-col>
                          <v-col cols="12" sm="6">
                              <v-list two-line
                                      rounded
                                      :color="$vuetify.theme.isDark ? 'kbLight' : ''"
                                      class="pa-0">
                                <v-list-item>
                                  <v-list-item-action>
                                    <v-switch color="info"
                                              :input-value="selectedTrigger.isActive"
                                              hide-details
                                              @change="changeTriggerStatus"/>
                                  </v-list-item-action>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      {{ $t('general.active') }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                          </v-col>
                      </v-row>
                  </v-card-text>
              </v-card>
          </v-col>
            <v-col cols="12">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <h4 class="kbDarkBlue--text"
                      id="title">
                    {{ $t('general.people') }}
                  </h4>
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="12" class="pa-0">
              <sent-users :items="triggerUsers"
                          :totalItems="totalTriggerUsers"
                          type="trigger"
                          :pagination="pagination"
                          :loading="loadingTrigger"
                          :showMessageType="true"
                          @setPagination="setPagination"/>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import SentUsers from '@/pages/App/Communications/SentUsers/SentUsers'
export default {
  components: { SentUsers },
  computed: {
    ...mapState({
      selectedTrigger: state => state.triggers.selectedTrigger,
      triggerUsers: state => state.triggers.triggerUsers,
      totalTriggerUsers: state => state.triggers.totalTriggerUsers
    })
  },
  data () {
    return {
      loadingTrigger: false,
      pagination: {}
    }
  },
  methods: {
    toggleModal () {
      this.$emit('input', false)
    },
    async changeTriggerStatus (status) {
      const trigger = this.selectedTrigger
      trigger.isActive = status
      try {
        await this.$store.dispatch('updateTrigger', trigger)
        this.$emit('changeTriggerStatus')
      } catch (e) {
        notifications.error(e)
      }
    },
    async getTrigger () {
      try {
        this.loadingTrigger = true
        await Promise.all([
          this.$store.dispatch('getTrigger', this.selectedTriggerId),
          this.$store.dispatch('getTriggerUsers', this.selectedTriggerId)
        ])
        this.loadingTrigger = false
      } catch (e) {
        this.loadingTrigger = false
        notifications.error(e)
      }
    },
    setPagination (pagination) {
      this.pagination = pagination
    }
  },
  props: {
    selectedTriggerId: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value (value) {
      if (value) {
        this.getTrigger()
      }
    }
  }
}
</script>
